var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAltItemLocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#000000;stroke-opacity:0.2;}\n\t.st2{fill:#CCCCCC;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,0L30,0c16.6,0,30,13.4,30,30l0,0c0,16.6-13.4,30-30,30l0,0C13.4,60,0,46.6,0,30l0,0C0,13.4,13.4,0,30,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30,0.5L30,0.5c16.3,0,29.5,13.2,29.5,29.5l0,0c0,16.3-13.2,29.5-29.5,29.5l0,0C13.7,59.5,0.5,46.3,0.5,30l0,0 C0.5,13.7,13.7,0.5,30,0.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.2,28.1v-3.3c0-3.9-3.2-7.1-7.2-7.1s-7.2,3.2-7.2,7.1v3.3c-1.6,0.2-2.8,1.5-2.8,3.1V40 c0,1.7,1.4,3.1,3.2,3.1h13.7c1.7,0,3.2-1.4,3.2-3.1v-8.8C40,29.6,38.8,28.3,37.2,28.1z M31,35.6c0,0.1,0,0.2,0,0.3V39 c0,0.6-0.5,1-1.1,1c-0.6,0-1.1-0.5-1.1-1v-3.1c0-0.1,0-0.2,0-0.3c-0.7-0.4-1.1-1-1.1-1.8c0-1.2,1-2.1,2.1-2.1s2.1,0.9,2.1,2.1 C32.1,34.6,31.7,35.3,31,35.6L31,35.6z M34.1,28.1h-8.1v-3.3c0-2.2,1.8-4,4.1-4s4.1,1.8,4.1,4V28.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltItemLocked);
export default __webpack_public_path__ + "static/media/alt_item_locked.48ff9a641de4c93c3896782ab323c1d6.svg";
export { ForwardRef as ReactComponent };